import { render, staticRenderFns } from "./NuevoRecibo.vue?vue&type=template&id=0234f39c&"
import script from "./NuevoRecibo.vue?vue&type=script&lang=js&"
export * from "./NuevoRecibo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports